export default {
  'team.title': 'Meet Our Team',
  'team.subtitle': 'Our diverse team of experts brings together decades of experience in technology, finance, and strategic investments to drive innovation and growth.',
  
  'team.roger.name': 'Roger Ekuh',
  'team.roger.position': 'President & CEO',
  'team.roger.bio': 'Experienced leader with a proven track record in financial technology and global business development.',
  
  'team.eveline.name': 'Dr. Eveline Ibeagha',
  'team.eveline.position': 'Finance & Admin',
  'team.eveline.bio': 'Expert in financial management and administrative operations with extensive experience in international banking.',
  
  'team.hasan.name': 'Hasan Kayar',
  'team.hasan.position': 'Technology',
  'team.hasan.bio': 'Technology innovator specializing in fintech solutions and digital transformation strategies.',
  
  'team.edmond.name': 'Edmond Mbong',
  'team.edmond.position': 'Corporate Affairs',
  'team.edmond.bio': 'Strategic leader in corporate communications and stakeholder relations with global expertise.',
};
